import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { FlatButton } from '../button/FlatButton';
import { DialogHeader } from '../dialog/DialogHeader';
import './DialogTypes.scss';

// #region Component Props

interface IProps {
    title           : string;
    body            : string;
    successCallback : any;
    cancelCallback  : any;
}

// #endregion

export class ConfirmationDialog extends React.Component<IProps> {

    public handleCancel = () => {
        this.props.cancelCallback();
    }

    public handleOkay = () => {
        this.props.successCallback();
    }

    public render() {

        const { title, body } = this.props;

        return <React.Fragment>

            <Dialog
                open={true}
                onClose={this.handleCancel}
                maxWidth="md"
                classes={{paper: "confirm-dialog-wrapper"}}
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1 className="confirmation-title-text">{ title }</h1>
                </DialogHeader>

                <DialogContent className="dialog-body-content">
                    <div className="row">
                        <div className="col">
                            <p className="confirmation-body-text">{ body }</p>
                        </div>
                    </div>                    
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="confirmyesBtn"
                        text="Yes"
                        classes="positive"
                        onBtnClick={ this.handleOkay } />
                    <FlatButton
                        id="confirmNoBtn"
                        text="No"
                        classes="negative"
                        onBtnClick={ this.handleCancel } />
                </DialogActions>
            </Dialog>
        </React.Fragment>;
    }
}
